import { Button } from "@devhop/ui";
import { useNavigate } from "@tanstack/react-router";
import { PlusIcon } from "lucide-react";
import { useActionPermission } from "@/modules/auth/presentation/model/useActionPermission";

type ShopsToolbarProps = Record<string, never>;

export function ShopsToolbar(_props: ShopsToolbarProps) {
  const nav = useNavigate({ from: "/app/shops" });
  const canCreate = useActionPermission(["shops:create"]);

  const onCreate = () => {
    nav({ to: "/app/shops/create" });
  };

  return (
    <div className="mb-2 flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between space-y-2">
        <div>
          <h2 className="font-bold text-2xl tracking-tight">ຮ້ານຄ້າ</h2>
          <p className="text-muted-foreground">ຈັດການຮ້ານຄ້າແລະສາຂາບນແຜງ.</p>
        </div>
        {canCreate && (
          <Button onClick={onCreate}>
            <PlusIcon className="size-4" />
            ເພີ່ມຮ້ານ
          </Button>
        )}
      </div>
    </div>
  );
}
